var getPixelRatio = function (context) {
  var backingStore = context.backingStorePixelRatio ||
    context.webkitBackingStorePixelRatio ||
    context.mozBackingStorePixelRatio ||
    context.msBackingStorePixelRatio ||
    context.oBackingStorePixelRatio ||
    context.backingStorePixelRatio || 1;
  return (window.devicePixelRatio || 1) / backingStore
}

function getLineMaxWidth (drawLine, firstStart, lineMaxWidth) {
  return drawLine === 1 ? lineMaxWidth - firstStart : lineMaxWidth
}

class Certificate {
  constructor ({ el, font, fillStyle, img }) {
    this.myCanvas = typeof el === 'string' ? document.getElementById(el) : el
    this.ctx = this.myCanvas.getContext('2d')
    this.ratio = getPixelRatio(this.ctx);
  
    this.myCanvas.style.width = this.myCanvas.width + 'px'
    this.myCanvas.style.height = this.myCanvas.height + 'px'
    this.myCanvas.width = this.myCanvas.width * this.ratio
    this.myCanvas.height = this.myCanvas.height * this.ratio
  
    if (img) {
      this.ctx.drawImage(img, 0, 0, this.myCanvas.width, this.myCanvas.height);
    }

    this.ctx.scale(this.ratio, this.ratio)
    this.ctx.font = font || '18px 微软雅黑'
    this.fillStyle = fillStyle || '#000'
  }

  fillContent ({
    name,
    nameFont,
    content,
    drawX,
    drawY,
    lineHeight,
    lineMaxWidth,
    lineNum
  }) {
    var temp = {
      font: this.ctx.font
    }

    lineHeight = this.ctx.font.match(/[0-9]+(?!=px)/)[0] * 1.5
    lineMaxWidth = lineMaxWidth || this.myCanvas.style.width.replace('px', '') * .8
    drawX = drawX || lineMaxWidth * .1
    drawY = drawY || drawX
    lineNum = lineNum || 99

    this.ctx.font = nameFont || 'bold 22px 微软雅黑'

    var drawTxt = ''
    var drawLine = 1
    var drawIndex = 0

    this.ctx.fillText(name, drawX, drawY);
    var firstStart = this.ctx.measureText(name).width + 8
    var firstLineMaxWidth = getLineMaxWidth(drawLine, firstStart, lineMaxWidth)
    this.ctx.font = temp.font

    if (this.ctx.measureText(content).width <= firstLineMaxWidth) {
      this.ctx.fillText(content.substring(drawIndex, i), drawX + firstStart, drawY);
    } else {
      for (var i = 0; i < content.length; i++) {
        drawTxt += content[i];
        var currentLineMaxWidth = drawLine === 1 ? firstLineMaxWidth : lineMaxWidth
        var currentDrawX = drawLine === 1 ? drawX + firstStart : drawX
        if (this.ctx.measureText(drawTxt).width >= currentLineMaxWidth) {
          if (drawLine >= lineNum) {
            this.ctx.fillText(content.substring(drawIndex, i) + '..', currentDrawX, drawY);
            break;
          } else {
            this.ctx.fillText(content.substring(drawIndex, i + 1), currentDrawX, drawY);
            drawIndex = i + 1;
            drawLine += 1;
            drawY += lineHeight;
            drawTxt = '';
          }
        } else {
          // 内容绘制完毕，但是剩下的内容宽度不到lineMaxWidth
          if (i === content.length - 1) {
            this.ctx.fillText(content.substring(drawIndex), currentDrawX, drawY);
          }
        }
      }
    }

    return this
  }

  fill ({
    content,
    drawX,
    drawY,
    font
  }) {
    const temp = this.ctx.font
    this.ctx.font = font
    this.ctx.fillText(content, drawX , drawY)
    this.ctx.font = temp.font
    return this
  }

  createCertificate ({
    name,
    content,
    time,
    code,
    teachers,
    type
  }) {
    if (type === 'outline') {
      teachers = Array.isArray(teachers) ? teachers.join('    ') : teachers.split('，').join('    ')
      this.createCertificateOutline({
        name,
        content,
        time,
        code,
        teachers
      })
    } else {
      this.createCertificateOnline({
        name,
        content,
        time,
        code
      })
    }
  }

  createCertificateOnline ({
    name,
    content,
    time,
    code
  }) {
    this.fillContent({
      name,
      content,
      drawY: 300,
      drawX: 120,
      lineMaxWidth: 600
    }).fill({
      content: time,
      drawX: 600,
      drawY: 463,
      font: '16px 微软雅黑'
    }).fill({
      content: '证书编号：' + code,
      drawX: 544,
      drawY: 130,
      font: '14px 微软雅黑'
    })
  }

  createCertificateOutline ({
    name,
    content,
    time,
    code,
    teachers
  }) {
    this.fillContent({
      name,
      content,
      drawY: 300,
      drawX: 120,
      lineMaxWidth: 600
    }).fill({
      content: time,
      drawX: 593,
      drawY: 463,
      font: '16px 微软雅黑'
    }).fill({
      content: '证书编号：' + code,
      drawX: 544,
      drawY: 130,
      font: '14px 微软雅黑'
    }).fill({
      content: teachers,
      drawX: 180,
      drawY: 447,
      font: '14px 微软雅黑'
    })
  }
}

export {
  Certificate
}
